import React from "react";
import useTranslationHook from "../../../../hooks/useTranslationHook";
const ConfirmRegistrationTypeChange = ({
    show,
    onClose,
    confirmSwitch,
    cancelSwitch,
}) => {
    const { t } = useTranslationHook();

    return (
        <div
            className={`modal fade place-bid-modal ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>
                            {t(
                                "Changing the registration type will reset your form."
                            )}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>

                    <div className="modal-body pb0">
                        <div className="placebid">
                            <ul className="bidlist">
                                <li>
                                    {t(
                                        "If you confirm, all previously entered details will be permanently removed. Do you want to proceed?"
                                    )}
                                </li>
                            </ul>

                            <div className="button-action">
                                <button
                                    type="button"
                                    className="btn btn-white btn-gray btn-lg"
                                    onClick={cancelSwitch}
                                >
                                    {t("Cancel")}
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg"
                                    onClick={confirmSwitch}
                                >
                                    {t("Confirm")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmRegistrationTypeChange;
